import React, { useState } from "react";
import TableDisplay from "./TableDisplay";
import * as Yup from "yup";
export default function RealVideo() {
  const [title, setTitle] = useState(["id", "video", "status"]);
  const formConfig = {
    fields: [
      {
        name: "video",
        label: "Video",
        type: "video",
      },
      {
        name: "status",
        label: "Status",
        type: "switch",
      },
    ],
    validationSchema: Yup.object({
      video: Yup.mixed().required("Please upload an image."),
    }),
  };

  const initialValues = {
    video: "",
    status: 0,
  };
  return (
    <div>
      <TableDisplay
        category="Real Video Data"
        tableurl="admin-get-realvideo"
        title={title}
        deleteurl="admin-delete-realvideo"
        deleteallurl="admin-all-delete-realvideo"
        addurl="add-realvideo"
        formConfig={formConfig}
        initialValues={initialValues}
        updateurl="get-edit-realvideo"
        updatteurl="admin-edit-realvideo"
        statusurl="admin-status-realvideo"
        axiosHeader={true}
      />
    </div>
  );
}
